import { IjsendOkResponse, isJsendFail } from "./jsend";

export const fetchRequest = async <T>(
  url: string,
  method: "GET" | "PUT" | "POST" | "DELETE" = "GET",
  errorMessage: string = "Errore",
  body?: string
): Promise<IjsendOkResponse<T> | undefined> => {

  let headers = new Headers();
  // headers.set("Authorization", "Basic bWFzc2k6bWFzc2k=");
  headers.set("Content-Type", "application/json");

  let options: RequestInit = {
    headers,
    method,
    credentials: 'include',
    body,
  };
  return fetch(url, options)
    .then(async (res) => {
      // try {
      const data = await res.json();
      if (isJsendFail(data)) throw new Error(JSON.stringify(data.data), { cause: data.code }); // using cause to pass the error code
      const error: string = data && data.message;
      if (error) throw new Error(error);
      if (!res.ok || !([200, 201, 204].includes(res.status))) throw new Error(errorMessage);
      return data as IjsendOkResponse<T>;
      // } catch (error) {
      //   if (!(error instanceof Error)) throw error;
      //   // alert(`${errorMessage} ${error.message}`);
      //   throw new Error(errorMessage + ' ' + error.message);
      // }
    })
    .catch((error) => {
      // if (!(error instanceof Error)) throw error;
      // throw new Error(errorMessage + ' ' + error.message);
      throw error
    });
};